<template>
    <div>
        <router-view name="applyRouter"></router-view>
    </div>
</template>

<script>
  export default {
    name: 'apply_main',
    mounted () {
    }
  }
</script>

<style>
</style>
